import * as React from 'react'

import {
  TableCell
} from '@mui/material'

import { styled } from '@mui/material/styles';

const CTableHCell = styled(TableCell)({
  background: '#EFF4FA',
  color: '#8F9BB3',
  border: 'none'
});

const CTableCell = styled(TableCell)({
  color: '#222B45'
});



export {
  CTableHCell,
  CTableCell
}